// extracted by mini-css-extract-plugin
export default {"termsContent":"Options_termsContent__tCJcx"};